export default __webpack_public_path__ + "static/media/Icons_Record_Bold.810abb65.svg";